import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { DireccionesPersonal } from '../../../../models/direcciones-personal';
import { PersonalService } from '../../../../services/personal.service';
import { DireccionesPersonalService } from '../../../../services/direcciones-personal.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';
import * as moment from 'moment';

@Component({
  selector: 'app-direcciones-list',
  templateUrl: './direcciones-list.component.html',
  styleUrls: ['./direcciones-list.component.css']
})
export class DireccionesListComponent implements OnInit {

  @Input() personalId: number;
  @Input() direcciones: DireccionesPersonal[];
  @Input() permisoEdicion: boolean = true;
  @Input() fechaslist;
  @Input() personal;
  @Output() VisualizarDetalle = new EventEmitter<DireccionesPersonal>();

  direccionesOri: DireccionesPersonal[];
  direccionesGrupo: DireccionesPersonal[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private direccionesPersonalService: DireccionesPersonalService,
              private personalSrv: PersonalService,
              private momentService: MomentSetService) {

   }

  ngOnInit(): void
  {
    this.direccionesOri = this.direcciones;
    this.inicializaFiltros();
    
    this.filtrarDirecciones();
      
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarDirecciones()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.direcciones = this.direccionesOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());    
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.direccionesGrupo == undefined)
      {
        this.direccionesPersonalService.getDirecciones(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
            });

            this.direccionesGrupo = data;
            this.direcciones = this.direccionesGrupo;
          });

      } else
      {
        this.direcciones = this.direccionesGrupo;
      }
      
    } else
    {
      this.filtrarDirecciones();
    }
  }

  onChangeFiltros()
  {
    this.filtrarDirecciones();
  }

  visualizarDetalle(direccion)
  {
    this.VisualizarDetalle.emit(direccion);
  }

  add()
  {
    let fdesde = new Date().toString();
    let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    if (fecha != undefined){
      fdesde = fecha.desde
    }  
    let direccion: DireccionesPersonal = { id: 0, personal: this.personalId, clase: 0, calle: '', codPos: 0, dpto: '', localidad: '', nro: 0, observaciones: '', piso: '', provincia: 0, pais: this.personal.nacionalidad, desde: fdesde, hasta: new Date("2999-12-31T23:59:59").toString(), telefono: '' };
    this.VisualizarDetalle.emit(direccion);
  }
}
